export default {
	type: 'object',
	properties: {
		brandName: { type: 'string' },
		brandWebsite: { type: 'string' },
		brandTwitter: { type: 'string' },
		// Protocol-less URL of a freshly uploaded logo original. The handler validates + resizes it into
		// the stored { small, big } only when it differs from the current logo.
		brandLogoUrl: { type: 'string' },
		id: { type: 'string' },
	},
	required: ['brandName', 'brandWebsite'],
	additionalProperties: false,
}
